import Header from "../components/Header";
import GridTileView from "../components/Views/GridTileView";
import { useQuery } from "@tanstack/react-query";
import { getEducations } from "../api";

export default function Education() {
  const educationQuery = useQuery({
    queryKey: [],
    queryFn: getEducations,
  });

  return (
    <div className="w-full text-center">
      <Header />
      <GridTileView data={educationQuery.data} keyWord="education" />
    </div>
  );
}
